import loadable from '@loadable/component';

export const TheweekusSiteWrapper = loadable(
  () => import(/* webpackChunkName: "theweekus-site" */ './TheweekusSiteWrapper'),
);
